// extracted by mini-css-extract-plugin
export var readonly = "_ha-1";
export var star = "_ha-0";